import React from 'react'
import Box from '@material-ui/core/Box'
import AccountAgentWalletForm from '../../../components/admin/account/AccountAgentWalletForm'
import AccountAgentWalletTable from '../../../components/admin/account/AccountAgentWalletTable'

const AccountAgentWalletPage: React.FC = () => {
  return (
    <Box paddingY={5}>
      <Box paddingX={5}>
        <AccountAgentWalletForm />
      </Box>
      <Box paddingTop={3}>
        <AccountAgentWalletTable />
      </Box>
    </Box>
  )
}

export default React.memo(AccountAgentWalletPage)
